import React, { Component } from 'react'
import { Popup } from 'devextreme-react/popup'
import Form from 'devextreme-react/form'
import httpRequest from 'plugin/httprequest';
import notify from 'devextreme/ui/notify';
import { showLoading } from "redux/actions/loading";
import { confirm } from 'devextreme/ui/dialog';
import { months } from 'dataSource/lookup';

class ModalKirimIuranBulanan extends Component {
    constructor(props) {
        super(props)

        this.state = {
            popupVisible: false,
            dataMaster: {}
        }

        this.show = this.show.bind(this)
        this.hide = this.hide.bind(this)

        this.popupRef = React.createRef()
        this.formRef = React.createRef()

        this.popupToolbarItem = [
            {
                widget: 'dxButton',
                location: 'after',
                options: {
                    'text': 'Simpan',
                    elementAttr: { class: "bg-button-popup-save-dapen-default" },
                    onClick: async () => {
                        let result = await confirm(`Apakah anda yakin ${this.state.dataMaster.typeNote === 'approved' ? 'mengirim' : 'membatalkan'} data ini?`, "Konfirmasi");
                        if (result) {
                            await this.submitData()
                        }
                    }
                },
                toolbar: 'bottom'
            },
            {
                widget: 'dxButton',
                location: 'after',
                options: {
                    'text': 'Batal',
                    elementAttr: { class: "bg-button-popup-close-dapen-default" },
                    onClick: () => {
                        this.hide()
                    }
                },
                toolbar: 'bottom'
            }
        ]

        this.formItems = [
            {
                itemType: 'group',
                caption: 'Iuran Bulanan',
                items: [
                    {
                        dataField: 'tahun',
                        label: {
                            text: 'Tahun'
                        },
                        editorType: 'dxNumberBox',
                        editorOptions: {
                            elementAttr: { class: "bd-input-popup-disabled-dapen-default" }
                        }
                    },
                    {
                        dataField: 'bulan',
                        label: {
                            text: 'Bulan'
                        },
                        editorType: 'dxSelectBox',
                        editorOptions: {
                            elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                            dataSource: months(),
                            valueExpr: 'id',
                            displayExpr: 'value',
                            searchEnabled: true,
                            deferRendering: false
                        }
                    },
                ]
            },
            {
                itemType: 'group',
                caption: 'Catatan',
                items: [
                    {
                        dataField: 'notes',
                        label: {
                            text: 'Catatan',
                            visible: false
                        },
                        editorType: 'dxTextBox',
                        editorOptions: {
                            elementAttr: { class: "bd-input-popup-area-dapen-default" },
                        }
                    }
                ]
            },
        ]
    }
    get Popup() {
        return this.popupRef.current.instance
    }

    show() {
        this.setState({
            popupVisible: true
        });
    }

    hide() {
        this.setState({
            popupVisible: false,
            dataMaster: {}
        })
    }

    retrieveData = (data, type) => {
        if (data) {
            this.setState({
                dataMaster: {
                    tahun: data.tahun,
                    bulan: data.bulan,
                    iuranId: data.id,
                    typeNote: type,
                    notes: ''
                }
            })
        }
    }

    submitData = async () => {
        this.props.store.dispatch(showLoading(true))
        try {
            const { iuranId, typeNote, notes } = this.state.dataMaster
            let param = {
                iuranId: iuranId,
                note: notes
            }

            await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `participant-iuran-uploads/send-iuran/${iuranId}`, 'POST', {
                values: param
            })
            this.props.store.dispatch(showLoading(false))
            this.hide()
            this.props.forceRefresh()
            notify({ message: `Berhasil ${typeNote === 'approved' ? 'mengirim' : 'membatalkan'} data`, width: 'AUTO', shading: true, position: { at: 'center', my: 'center', of: window } }, 'success', 1000);

        } catch (e) {
            console.log(e)
            this.props.store.dispatch(showLoading(false))
            notify({ message: e, width: 'AUTO', shading: true, position: { at: 'center', my: 'center', of: window } }, 'error', 1000);
        }
    }

    render() {
        return (
            <Popup
                className={'popup'}
                visible={this.state.popupVisible}
                onHiding={this.hide}
                dragEnabled={true}
                showTitle={true}
                title={`${this.state.dataMaster.typeNote === 'approved' ? 'Form Kirim Iuran Bulanan' : 'Form Batal Iuran Bulanan'}`}
                width={"30vw"}
                height={"40vh"}

                ref={this.popupRef}

                toolbarItems={this.popupToolbarItem}
            >
                <div className="container-fluid">
                    <div className='row'>
                        <div className="col-12">
                            {
                                this.state.popupVisible &&
                                <Form
                                    colCount={1}
                                    labelLocation='left'
                                    id={'formNote'}
                                    ref={this.formRef}
                                    formData={this.state.dataMaster}
                                    items={this.formItems}
                                />
                            }
                        </div>
                    </div>
                </div>
            </Popup>
        )
    }
}

export default ModalKirimIuranBulanan